import { render } from "./AddBasedOnIcon.vue?vue&type=template&id=2494d1ac&scoped=true"
import script from "./AddBasedOnIcon.vue?vue&type=script&lang=js"
export * from "./AddBasedOnIcon.vue?vue&type=script&lang=js"

import "./AddBasedOnIcon.vue?vue&type=style&index=0&id=2494d1ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2494d1ac"

export default script